var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTravelGuide(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.32 3.00132L13.32 0.780463H13.25C13.2034 0.775268 13.1565 0.775268 13.11 0.780463H12.88H12.75H12.68L7 2.94579L1.32 0.780463C1.16962 0.725398 1.00961 0.710778 0.853138 0.737805C0.69667 0.764833 0.548219 0.832734 0.420003 0.935922C0.290762 1.0381 0.185268 1.17296 0.112238 1.32935C0.039208 1.48575 0.000736953 1.6592 3.33353e-06 1.83537V17.3813C-0.000537828 17.6141 0.0648223 17.8412 0.186845 18.0305C0.308868 18.2198 0.481382 18.3617 0.680003 18.4362L6.68 20.6571C6.88145 20.73 7.09855 20.73 7.3 20.6571L13 18.5473L18.68 20.7126C18.7862 20.7286 18.8938 20.7286 19 20.7126C19.2091 20.7159 19.4132 20.6416 19.58 20.5016C19.7092 20.3995 19.8147 20.2646 19.8878 20.1082C19.9608 19.9518 19.9993 19.7784 20 19.6022V4.05622C20.0005 3.82343 19.9352 3.59633 19.8132 3.40703C19.6911 3.21773 19.5186 3.07581 19.32 3.00132ZM6 18.0587L2 16.5818V3.37886L6 4.85573V18.0587ZM12 16.5818L8 18.0587V4.85573L12 3.37886V16.5818ZM18 18.0587L14 16.5818V3.37886L18 4.85573V18.0587Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTravelGuide);
export default __webpack_public_path__ + "static/media/travelGuide.2156b8087bdef2c6ad86fb9fd0d44532.svg";
export { ForwardRef as ReactComponent };